import api from './api';

const API_BASE = (import.meta.env.VITE_API_URL || 'http://localhost:8000/api/v1').replace(/\/+$/, '');

const toWebSocketBase = () => {
  const origin =
    typeof window !== 'undefined' && window.location?.origin
      ? window.location.origin
      : 'http://localhost:8000';
  const wsUrl = new URL(API_BASE || '/api/v1', origin);
  wsUrl.protocol = wsUrl.protocol === 'https:' ? 'wss:' : 'ws:';
  return wsUrl.toString().replace(/\/+$/, '');
};

export const audioToolsService = {
  async speechToText(file) {
    const formData = new FormData();
    formData.append('audio_file', file);
    const response = await api.post('/audio-tools/speech-to-text', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  connectRealtimeSpeechToText(token) {
    const wsBase = toWebSocketBase();
    return new WebSocket(`${wsBase}/audio-tools/speech-to-text/realtime?token=${encodeURIComponent(token)}`);
  },

  async voiceChanger(file, options = {}) {
    const formData = new FormData();
    formData.append('audio_file', file);
    formData.append('pitch_shift_semitones', `${options.pitchShiftSemitones ?? 0}`);
    formData.append('speed', `${options.speed ?? 1}`);
    formData.append('gain_db', `${options.gainDb ?? 0}`);

    const response = await api.post('/audio-tools/voice-changer', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      responseType: 'blob',
    });
    return response.data;
  },

  async textToSoundEffects(prompt, options = {}) {
    const response = await api.post(
      '/audio-tools/sound-effects',
      {
        prompt,
        duration_seconds: options.durationSeconds ?? 2.0,
        intensity: options.intensity ?? 0.7,
        sample_rate: options.sampleRate ?? 22050,
      },
      { responseType: 'blob' }
    );
    return {
      audioBlob: response.data,
      effectType: response.headers['x-effect-type'] || 'chime',
    };
  },

  async voiceIsolator(file, options = {}) {
    const formData = new FormData();
    formData.append('audio_file', file);
    formData.append('strength', `${options.strength ?? 0.7}`);

    const response = await api.post('/audio-tools/voice-isolator', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
      responseType: 'blob',
    });
    return response.data;
  },
};

export default audioToolsService;
